// extracted by mini-css-extract-plugin
export default {"cardContainer":"KanbanCard_cardContainer__CiSjj","cardContainerDragging":"KanbanCard_cardContainerDragging__8hyIF","card":"KanbanCard_card__juF13"};